import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-area-meta',
    templateUrl: './area-meta.component.html',
    styleUrls: ['./area-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('area-meta')
export class AreaMetaComponent {
    model = input<any>();

    metaMaxLength: any = { id: 'maxLength', name: 'Max Length', min: 1 };
    metaRows: any = { id: 'rows', name: 'Size in Rows', min: 2 };
}
